import { useQuery } from '@tanstack/react-query';

import getReportHostSummary from 'Api/report/getReportHostSummary';
import getReportBrand from 'Api/report/getReportBrand';
import getReportSession from 'Api/report/getReportSession';
import getReportAccountPlatform from 'Api/report/getReportAccountPlatform';

import { useReportState } from 'View/report/state';

import getReportHostSummaryResponse from './model/response/getReportHostSummaryResponse';
import getReportHostSummaryRequest from './model/request/getReportHostSummaryRequest';
import getReportBrandRequest from './model/request/getReportBrandRequest';
import getReportSessionRequest from './model/request/getReportSessionRequest';
import getReportSessionResponse from './model/response/getReportSessionResponse';
import getReportAccountPlatformRequest from './model/request/getReportAccountPlatformRequest';
import getReportAccountPlatformResponse from './model/response/getReportAccountPlatformResponse';
import getReportBrandResponse from './model/response/getReportBrandResponse';

const useGetReport = () => {
  const { state, filterState } = useReportState();

  return useQuery({
    queryKey: ['report', filterState, state?.selectedTab],
    queryFn: async () => {
      let queries;
      let response;
      let result;

      switch (state?.selectedTab) {
        case 'brand':
          queries = getReportBrandRequest(filterState);

          response = await getReportBrand(queries);

          result = getReportBrandResponse(response);

          break;

        case 'host':
          queries = getReportHostSummaryRequest(filterState);

          response = await getReportHostSummary(queries);

          result = getReportHostSummaryResponse(response);

          break;

        case 'session':
          queries = getReportSessionRequest(filterState);

          response = await getReportSession(queries);

          result = getReportSessionResponse(response);

          break;

        case 'accountPlatform':
          queries = getReportAccountPlatformRequest(filterState);

          response = await getReportAccountPlatform(queries);

          result = getReportAccountPlatformResponse(response);

          break;

        default:
          break;
      }

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetReport;
